function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: "inherit",
  d: "M26 54.5V97a5 5 0 005 5h66a5 5 0 005-5V56.5m-76-28a2.5 2.5 0 012.5-2.5h71a2.5 2.5 0 012.5 2.5V33H26v-4.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 13,
  x: 68,
  y: 72,
  stroke: "currentColor",
  strokeWidth: "inherit",
  rx: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: "inherit",
  d: "M40 74.5a2.5 2.5 0 012.5-2.5h13a2.5 2.5 0 012.5 2.5V102H40V74.5zM57 33h14l1.431 14.768a8.47 8.47 0 01-4.734 8.44v0a8.47 8.47 0 01-7.394 0v0a8.47 8.47 0 01-4.734-8.44L57 33zM71 33h16l1.518 15.666a7.554 7.554 0 01-3.9 7.36v0a7.554 7.554 0 01-7.236 0l-.44-.24a8.473 8.473 0 01-4.375-6.62L71 33zm16 0h13.952c.602 0 1.112.442 1.199 1.037l2.178 14.985a6.898 6.898 0 01-3.358 6.958v0a6.9 6.9 0 01-6.942 0l-.629-.366a8.151 8.151 0 01-3.966-5.872L87 33zm-61.15 1.037A1.212 1.212 0 0127.047 33H41l-2.434 16.742a8.151 8.151 0 01-3.966 5.872l-.629.366a6.901 6.901 0 01-6.942 0v0a6.901 6.901 0 01-3.358-6.958l2.178-14.985zM41 33h16l-1.567 16.166a8.473 8.473 0 01-4.375 6.62l-.44.24a7.554 7.554 0 01-7.236 0v0a7.554 7.554 0 01-3.9-7.36L41 33z"
});

function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "20 20 88 88"
  }, props), _ref, _ref2, _ref3);
}

export default SvgStore;